import React from 'react'

import { XStack } from 'tamagui'
import { Metadata } from '@newComponents/Metadata'
import { GradientBackgroundScreen } from '@newComponents/Screen'
import { Card } from '@newComponents/Card'

import { EventNewContent } from './EventNewContent'

export const EventNewScreen = () => {
  return (
    <>
      <Metadata title='New Event' />
      <GradientBackgroundScreen>
        <XStack justifyContent='center'>
          <Card maxWidth={600} flex={1}>
            <EventNewContent />
          </Card>
        </XStack>
      </GradientBackgroundScreen>
    </>
  )
}

export default EventNewScreen
